import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import {
  getDocFileAction,
  getDocTitleAction,
  setDocFileAction,
} from 'store/actions/documentActions';
import { IconGraphy, Loading } from '@leapeasy/ui-kit';

const formatDocumentDate = (createdDate) => {
  if (!createdDate || typeof createdDate !== 'string') return '';
  return createdDate.split('T')[0];
};

export const DocuList = ({ data }) => {
  const dispatch = useDispatch();
  const docs = useSelector((state) => state.get('doc'));
  const [title, setDocTitle] = useState(null);
  const { file } = docs;
  const docTitles = Array.isArray(docs.title) ? docs.title : null;
  const docError = docs.error;

  useEffect(() => {
    dispatch(getDocTitleAction(data));
  }, [data, dispatch]);

  const getMimetype = (signature) => {
    switch (signature) {
      case '89504E47':
        return '.png';
      case '47494638':
        return '.gif';
      case '25504446':
        return '.pdf';
      case 'FFD8FFDB':
      case 'FFD8FFE0':
      case 'FFD8FFE1':
        return '.jpeg';
      case '504B0304':
        return 'application/zip';
      default:
        return '.pdf';
    }
  };

  const downloadfile = useCallback(
    async (dlFile, downloadTitle) => {
      const buffer = await dlFile.arrayBuffer();
      const uint8array = new Uint8Array(buffer);
      const bytes = [];
      uint8array.forEach((byte) => {
        bytes.push(byte.toString(16));
      });
      const hex = bytes.slice(0, 4).join('').toUpperCase();
      const type = getMimetype(hex);
      const fileURL = window.URL.createObjectURL(new Blob([dlFile]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', `${downloadTitle || 'document'}${type}`);
      fileLink.setAttribute('target', '_blank');
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
      window.URL.revokeObjectURL(fileURL);
      dispatch(setDocFileAction(null));
    },
    [dispatch],
  );

  useEffect(() => {
    if (file && title) {
      downloadfile(file, title);
    }
  }, [file, title, downloadfile]);

  return (
    <DocuListContainer>
      {docError ? (
        <div>{docError}</div>
      ) : docTitles ? (
        docTitles.length > 0 ? (
          docTitles.map((doc, index) => (
            <ListDiv
              key={doc.docId || `${doc.title}-${index}`}
              onClick={() => {
                setDocTitle(doc.title);
                dispatch(getDocFileAction(doc.docId));
              }}
            >
              <IconGraphy icon="FileFolder.Pdf" />
              <div>
                <p>{doc.title}</p>
                {formatDocumentDate(doc.createdDate) ? (
                  <p>{formatDocumentDate(doc.createdDate)}</p>
                ) : null}
              </div>
              <IconGraphy icon="Arrow.FileDownload" />
            </ListDiv>
          ))
        ) : (
          <div>No Insurance Docs Found</div>
        )
      ) : (
        <LoadingContainer>
          <Loading size={'large'} />
        </LoadingContainer>
      )}
    </DocuListContainer>
  );
};

const DocuListContainer = styled.div`
  flex: 1;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const LoadingContainer = styled.div`
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ListDiv = styled.div`
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid rgba(234, 234, 234, 1);
  padding: 16px;
  margin: 10px 0;

  svg {
    width: 30px;
    color: rgba(46, 15, 64, 1);
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  div {
    flex: 1;

    & > p:nth-child(1) {
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 5px;
    }
    & > p:nth-child(2) {
      font-size: 10px;
      color: rgba(106, 94, 113, 1);
    }
  }

  &:hover {
    background-color: rgba(46, 15, 64, 0.08);
  }
`;
